var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53335 0C4.26823 0 0 4.26823 0 9.53335C0 14.7985 4.26823 19.0667 9.53335 19.0667C14.7985 19.0667 19.0667 14.7985 19.0667 9.53335C19.0667 4.26823 14.7985 0 9.53335 0ZM1.46667 9.53335C1.46667 5.07825 5.07825 1.46667 9.53335 1.46667C13.9885 1.46667 17.6 5.07825 17.6 9.53335C17.6 13.9885 13.9885 17.6 9.53335 17.6C5.07825 17.6 1.46667 13.9885 1.46667 9.53335Z",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8742 16.8371C17.5878 16.5507 17.1235 16.5507 16.8371 16.8371C16.5507 17.1235 16.5507 17.5878 16.8371 17.8742L20.7481 21.7853C21.0345 22.0717 21.4988 22.0717 21.7852 21.7853C22.0716 21.4989 22.0716 21.0346 21.7852 20.7482L17.8742 16.8371Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifyingGlass.9f24e739acfb222173a04ad99ed4cb6a.svg";
export { ForwardRef as ReactComponent };